import React, { useRef, useEffect } from "react";

function HospitalImagePopup({ image, onClose }) {
  const popupRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (popupRef.current && !popupRef.current.contains(event.target)) {
        onClose(); // Close when clicking outside
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [onClose]);

  // Construct full image URL
  const imageUrl = image?.startsWith("http")
    ? image
    : `${process.env.REACT_APP_BASE_URL}${image}`;

  return (
    <div className="fixed inset-0 bg-gray-800 bg-opacity-50 flex justify-center items-center z-50">
      {/* Click outside this div should close the popup */}
      <div
        ref={popupRef}
        className="bg-white rounded-lg p-4 shadow-lg relative"
      >
        <button
          className="absolute top-2 right-2 text-gray-500 hover:text-gray-700 text-2xl"
          onClick={onClose}
        >
          &times;
        </button>
        <div className="flex justify-center items-center">
          <img
            src={imageUrl}
            alt="Hospital Logo"
            className="w-64 h-64 rounded-md object-cover"
          />
        </div>
      </div>
    </div>
  );
}

export default HospitalImagePopup;
